export default __webpack_public_path__ + "static/media/blue_buffalo.635e1780.svg";